import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { isChunkLoadError, reloadForStaleChunk } from "@/lib/chunkReload";

// Chunk que sumiu no deploy (rotas lazy e imports dinâmicos de export). O erro segue para quem
// chamou: o ErrorBoundary mostra "carregando" enquanto a página recarrega.
window.addEventListener("vite:preloadError", (event) => {
  if (isChunkLoadError(event.payload)) reloadForStaleChunk();
});

// Global Headers patch: sanitize all header values to prevent
// "non ISO-8859-1 code point" errors from the Lovable preview proxy
const sanitize = (v: string) => String(v).replace(/[\u0100-\uffff]/g, ''); // sem a flag u, equivale a [^\x00-\xff]

// Patch the Headers constructor to sanitize on creation
const _OrigHeaders = globalThis.Headers;
globalThis.Headers = class PatchedHeaders extends _OrigHeaders {
  constructor(init?: HeadersInit) {
    if (init) {
      // Sanitize before passing to the real constructor
      if (init instanceof _OrigHeaders) {
        const clean: [string, string][] = [];
        init.forEach((v, k) => clean.push([k, sanitize(v)]));
        super(clean);
      } else if (Array.isArray(init)) {
        super(init.map(([k, v]) => [k, sanitize(v)] as [string, string]));
      } else {
        const clean: Record<string, string> = {};
        for (const [k, v] of Object.entries(init)) {
          clean[k] = sanitize(v);
        }
        super(clean);
      }
    } else {
      super();
    }
  }
};

// Also patch set/append for any later mutations
const _origSet = _OrigHeaders.prototype.set;
const _origAppend = _OrigHeaders.prototype.append;
globalThis.Headers.prototype.set = function (name: string, value: string) {
  return _origSet.call(this, name, sanitize(value));
};
globalThis.Headers.prototype.append = function (name: string, value: string) {
  return _origAppend.call(this, name, sanitize(value));
};

createRoot(document.getElementById("root")!).render(<App />);
